import React, { useEffect, useState } from "react";
import { useIntl  } from 'react-intl';
import { notification } from 'antd';
import axios from 'axios';

const PrintersCostPane = (props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get("/printing_cost")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Ошибка загрузки данных:", error);
      });
  }, []); // пустой массив = выполнить 1 раз при открытии

  return (
    <div>
      {data ? JSON.stringify(data) : "Загрузка..."}
    </div>
  );
};
  
export default PrintersCostPane;